import type { Translation } from '../types.ts';
import type en from '../en/common.ts';

export default {
    actions: {
        add: 'Toevoegen',
        apply: 'Toepassen',
        back: 'Terug',
        cancel: 'Annuleren',
        close: 'Sluiten',
        copy: 'Kopiëren',
        create: 'Aanmaken',
        delete: 'Verwijderen',
        discard: 'Verwerpen',
        download: 'Downloaden',
        edit: 'Bewerken',
        import: 'Importeren',
        next: 'Volgende',
        previous: 'Vorige',
        refresh: 'Vernieuwen',
        remove: 'Verwijderen',
        save: 'Opslaan',
        search: 'Zoeken',
        upload: 'Uploaden',
        view: 'Bekijken',
    },
    state: {
        loading: 'Laden…',
        saving: 'Opslaan…',
        deleting: 'Verwijderen…',
        uploading: 'Uploaden…',
        saved: 'Opgeslagen',
        active: 'Actief',
        inactive: 'Inactief',
        on: 'Aan',
        off: 'Uit',
        draft: 'Concept',
        published: 'Gepubliceerd',
        unsaved: 'Niet-opgeslagen wijzigingen',
    },
    fields: {
        name: 'Naam',
        title: 'Titel',
        description: 'Omschrijving',
        email: 'E-mail',
        phone: 'Telefoon',
        status: 'Status',
        type: 'Type',
        code: 'Code',
        slug: 'Slug',
        url: 'URL',
        language: 'Taal',
        created: 'Aangemaakt',
        updated: 'Bijgewerkt',
        price: 'Prijs',
        amount: 'Bedrag',
        total: 'Totaal',
        country: 'Land',
        image: 'Afbeelding',
        actions: 'Acties',
    },
    words: {
        yes: 'Ja',
        none: 'Geen',
        default: 'Standaard',
        from: 'Van',
        to: 'Tot',
        or: 'of',
    },
    messages: {
        fixErrors: 'Verbeter de gemarkeerde velden en sla opnieuw op.',
    },
    count: {
        selected: '{n} geselecteerd',
    },
} satisfies Translation<typeof en>;
